import React from 'react';
import { Card } from 'react-bootstrap';

const TotalUsersCard = ({ loading, count }) => {
  return (
    <Card className="mb-2">
      <Card.Body>
        <Card.Title className="fs-6">総ユーザ数（有効）</Card.Title>
        <div className="fs-2 fw-bold">
          {loading ? '...' : count}
        </div>
        <div className="small text-muted">
          
        </div>
      </Card.Body>
    </Card>
  );
};

export default TotalUsersCard;
